export default __webpack_public_path__ + "static/trifork-a2d2b330429fee41edc62f4974e0d46e.svg";